export default __webpack_public_path__ + "static/media/uv0_kr_star_b1.8e24fd76.mp3";